import { useState, useEffect } from 'react';
import useStore from './store';
import { decorationRepository } from '../../../domain/decorationsRepository';


export const useDecorationPortraits = () => {

    const data = useStore((state) => state.decorationPortraitList)
    const setData = useStore((state) => state.setDecorationPortraitList)

    const [isLoading, setIsLoading] = useState(true);

    console.log(`DEC_TEST data?.length: ${data?.length}`)

    useEffect(() => { // Axios request use to be inside useEffect to get executed once.
        if (!data?.length) {
            decorationRepository.getDecorationPortraits()
                .then((data) => {
                    setData(data)
                    setIsLoading(false)
                })
                .catch((err) => {
                    console.error("Failed to fetch decoration portraits:", err)
                    setIsLoading(false)
                });
        } else {
            setIsLoading(false)
        }
    }, [data, setData]);

    return { data, isLoading };
};